"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import { isValidElement } from 'react';
import { isPropsWithChildren } from './isPropsWithChildren.mjs';
import { pickPropsContext } from './pickPropsContext.mjs';
import { PropsContextProvider } from '../PropsContextProvider.mjs';

const wrapChildrenWithNestedPropsContext = (contextProps, localProps) => {
  if (!isPropsWithChildren(localProps)) {
    return {};
  }
  const childrenProp = localProps.children;
  if (!Array.isArray(childrenProp) && !isValidElement(childrenProp)) {
    return {};
  }
  const nestedPropsContext = pickPropsContext(contextProps);
  const isNestedPropsContextEmpty = Object.keys(nestedPropsContext).length === 0;
  if (isNestedPropsContextEmpty) {
    return {};
  }
  return {
    children: /* @__PURE__ */ jsx(PropsContextProvider, { props: nestedPropsContext, mergeInParentContext: true, children: childrenProp })
  };
};

export { wrapChildrenWithNestedPropsContext as default, wrapChildrenWithNestedPropsContext };
//# sourceMappingURL=wrapChildrenWithNestedPropsContext.mjs.map
